var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playerAll"},[_c('aplayer',{ref:"aplayerAll",staticClass:"musicPlayer",attrs:{"theme":"#45d585","loop":"none","audio":_vm.currentMusicAll},on:{"play":_vm.playFun}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }